module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('d-modal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    }
  }, [_c('div', {
    staticClass: "print-all-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "print-calendars__header border-1-bottom text-dark"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.print_latest_version')))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "print-all-modal__body"
  }, [(!_vm.isShowUserSelectModal) ? _c('div', {
    attrs: {
      "id": "printTaskOverviews"
    }
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : [(_vm.sortedUsers.length < 1) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.task_versions.no_saved_versions')) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('TaskOverviewUser', {
      key: user.user.id,
      attrs: {
        "user": user.user,
        "version": user.version,
        "schoolThresholdToHideTaskHours": _vm.schoolThresholdToHideTaskHours,
        "isHideTaskHoursUnderThreshold": _vm.isHideTaskHoursUnderThreshold
      }
    })
  })]], 2) : _vm._e()]), _vm._v(" "), (_vm.isShowUserSelectModal) ? _c('d-modal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    }
  }, [_c('div', {
    staticClass: "d-modal__content d-modal__content__hide-task-hours",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-container__header"
  }, [_c('h3', [_vm._v("Vælg brugere til udskrift")])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__body"
  }, [(_vm.tags.length > 0) ? _c('div', {
    staticClass: "brutto__users__header"
  }, [_c('filterTags', {
    attrs: {
      "users": _vm.usersSortedOnNameWithTags,
      "tags": _vm.tags,
      "selectedTags": _vm.appliedFilters
    },
    on: {
      "set": _vm.setTagFromFilter,
      "remove": _vm.removeTagFromFilter
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brutto__users__list__header",
    on: {
      "click": _vm.toggleAll
    }
  }, [(_vm.selectedUserIds.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('ul', {
    staticClass: "brutto__users__list"
  }, _vm._l((_vm.filteredUsersOnTags), function(user) {
    return _c('li', {
      key: user.id,
      staticClass: "brutto__users__user",
      class: {
        'is-selected': _vm.getIsUserSelected(user)
      },
      on: {
        "click": function($event) {
          return _vm.toggleUser(user)
        }
      }
    }, [_vm._v("\n              " + _vm._s(user.name) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__footer"
  }, [_c('div', {
    staticClass: "input-group input-group__toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setIsHideTaskHoursUnderThreshold.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "d-label marg-1-right"
  }, [_vm._v("Skjul timepuljer på opgaver under " + _vm._s(_vm.schoolThresholdToHideTaskHours) + "\n              timer")]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isHideTaskHoursUnderThreshold
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-modal__print_buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isLoadingPrint
    },
    on: {
      "click": _vm.startPrint
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.print')) + "\n            ")])])])])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36534b01!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Print/PrintTaskOverviews.vue
// module id = 1854
// module chunks = 1